// extracted by mini-css-extract-plugin
module.exports = {"teacher-title":"Teacher-module--teacher-title--XkB8A"};